const wholesaleForms = [...document.querySelectorAll(".js-wholesale-form")];

wholesaleForms.map((form) => {

   form.addEventListener("submit", async (e) => {
       e.preventDefault();

       const addToCart = form.querySelector('.js-add-to-cart');

       addToCart.innerHTML = "Toevoegen...";

       const items = []; // Lege array om de items op te slaan

       // Haal alle hidden id inputs en quantity inputs op
       const idInputs = form.querySelectorAll('input[name*="[id]"]');
       const quantityInputs = form.querySelectorAll('input[name*="[quantity]"]');

       idInputs.forEach((idInput, index) => {
           const id = parseInt(idInput.value);
           const quantity = parseInt(quantityInputs[index].value);

           // Voeg alleen toe aan de array als de quantity groter is dan 0
           if (quantity > 0) {
               items.push({ id, quantity });
           }
       });

       const requestBody = {
           items: items
       };

       // Add products to cart
       await fetch(`${window.Shopify.routes.root}cart/add.js`, {
           method: "POST",
           headers: {
               "Content-Type": "application/json",
           },
           body: JSON.stringify(requestBody),
       });


       // Get updated cart data
       const res = await fetch("/cart.json");
       const cart = await res.json();

       // Update cart count
       document.querySelectorAll(".cart-count-bubble").forEach((el) => {
           el.textContent = cart.item_count;
       });

       addToCart.innerHTML = "✅ Voeg toe +";
   });

});

document.querySelectorAll("form.configurator-form").forEach((form) => {
    form.addEventListener("submit", async (e) => {
        e.preventDefault();

        // Show loading spinner
        const loadingOverlays = document.querySelectorAll(".loading-overlay");
        loadingOverlays.forEach((overlay) => overlay.classList.remove("hidden"));

        // Collect product data
        const productData = selectedProducts.map((product) => ({
            id: product.id,
            quantity: 1,
            variantId:
                product.variantId && product.variantId !== product.id
                    ? parseInt(product.variantId)
                    : undefined,
        }));

        const requestBody = {
            items: productData,
        };

        // Add products to cart
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        // Get updated cart data
        const res = await fetch("/cart.json");
        const cart = await res.json();

        // Update cart count
        document.querySelectorAll(".cart-count-bubble").forEach((el) => {
            el.textContent = cart.item_count;
        });

        // Navigate to cart page
        window.location.href = "/cart";
    });
});